import { completedBatchStatuses } from "../constants/completedBatchStatuses";

export const getMinerFee = (batchStatus: number, fee: string) => {
  const minerFee = completedBatchStatuses.includes(batchStatus) ? fee : "";

  return minerFee;
};
